import axios from '@utils/axios-client'

export interface IAppConfig {
    displayMode: '2D' | '3D'
    is2D: boolean
}

class DataAPI {
    // Get app config (2D/3D display mode) from the backend.
    // BE endpoint: UserController.GetAppConfig (AllowAnonymous) -> ApiResult<AppConfigResponse>
    getDisplayMode() {
        const url = `/api/v1/User/GetAppConfig`
        return axios.get<{ data: IAppConfig }>(url)
    }
}

export const dataAPI = new DataAPI()
